// Libs
import _filter from 'lodash/filter'

export default (operation: Object) : Array<Object> => {
  return _filter(operation, function (subOp) {
    return subOp.operation === 'ADD'
  })[0]
}
